function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useContext, useRef, useMemo, useState } from 'react';
import { MDText } from 'i18n-react';
import PropTypes from 'prop-types';
import { getOrCreateGlobalContext, CONTEXT_NAMES } from '../globalContexts';
import { defaultLocale, supportedLocales } from './consts';
import { createTranslationLoader } from './TLoader';
var LocaleContext = getOrCreateGlobalContext(CONTEXT_NAMES.LocaleContext);

/**
 * @name useCustomLocale - this function allows you to load a custom locale regardless of the provider.
 * @param {function} translationFileLoader - function to load translation file.
 * @param {string} locale [defaultLocale]
 * @param {function} setLocale
 */
var useCustomLocale = function useCustomLocale(translationFileLoader) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultLocale;
  var setLocale = arguments.length > 2 ? arguments[2] : undefined;
  var translationFileLoaderRef = useRef(translationFileLoader);
  var T = useMemo(function () {
    var translations = createTranslationLoader({
      translationFileLoader: translationFileLoaderRef.current
    })(locale);
    return new MDText(translations || {});
  }, [locale]);
  return {
    T: T,
    locale: locale,
    setLocale: setLocale
  };
};
/**
 * @name useLocale - this function allows you to load a locale using the locale from the provider.
 * @param {function} translationFileLoader - function to load translation file.
 */


export var useLocale = function useLocale(translationFileLoader) {
  var contextValue = useContext(LocaleContext);
  return useCustomLocale(translationFileLoader, contextValue === null || contextValue === void 0 ? void 0 : contextValue.locale, contextValue === null || contextValue === void 0 ? void 0 : contextValue.setLocale);
};
export var LocaleProvider = function LocaleProvider(_ref) {
  var children = _ref.children,
      locale = _ref.locale;
  var browserLanguage = supportedLocales.find(function (l) {
    return l === navigator.language;
  });

  var _useState = useState(browserLanguage || defaultLocale),
      _useState2 = _slicedToArray(_useState, 2),
      customLocale = _useState2[0],
      setCustomLocale = _useState2[1];

  return /*#__PURE__*/React.createElement(LocaleContext.Provider, {
    value: {
      locale: locale || customLocale,
      setLocale: setCustomLocale
    }
  }, children);
};
LocaleProvider.propTypes = {
  children: PropTypes.node.isRequired,
  locale: PropTypes.string
};
export { defaultLocale, supportedLocales };
//# sourceMappingURL=index.js.map